var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgImage = function SvgImage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12 16.002 4.588-4.588a2 2 0 0 1 2.83 0L21.003 13M3.349 18.647l4.232-4.232a2 2 0 0 1 2.83 0l6.419 6.42M2.996 6.998a4.002 4.002 0 0 1 4.002-4.002h10.004a4.002 4.002 0 0 1 4.002 4.002v10.004a4.002 4.002 0 0 1-4.002 4.002H6.998a4.002 4.002 0 0 1-4.002-4.002V6.998Zm6.003.5a1.5 1.5 0 1 1-3.002 0 1.5 1.5 0 0 1 3.002 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImage);
export default ForwardRef;